(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.ZonesDeleteDialogHandler = (function(superClass) {
    extend(ZonesDeleteDialogHandler, superClass);

    function ZonesDeleteDialogHandler() {
      return ZonesDeleteDialogHandler.__super__.constructor.apply(this, arguments);
    }

    ZonesDeleteDialogHandler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/zones/zones/load-delete-dialog';
      this.saveUrl = 'backend/portal/zones/zones/delete';
      this.classes = 'small_dialog';
      return this.createDialog();
    };

    ZonesDeleteDialogHandler.prototype.afterLoadLayout = function(selector, response) {
      var ref;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      return this.dialog.find('.save-btn').on('click', (function(_this) {
        return function() {
          return _this.save('Deleting zone...');
        };
      })(this));
    };

    return ZonesDeleteDialogHandler;

  })(DialogHandler);

}).call(this);
